import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Collections from "@/pages/collections/page";
import CollectionDetail from "@/pages/collection-detail/page";
import Weekly from "@/pages/weekly/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/collections",
    element: <Collections />,
  },
  {
    path: "/collection/:id",
    element: <CollectionDetail />,
  },
  {
    path: "/weekly",
    element: <Weekly />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;